export default __webpack_public_path__ + "static/media/image6.44927943.png";